export default "__VITE_ASSET__BgB$ZVXZ__"